var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.339 9.028c.314.288.346.75.09 1.072l-.07.078-4.851 4.774a.89.89 0 0 1-1.17.055l-.074-.069-4.637-4.773a.787.787 0 0 1 .048-1.15.89.89 0 0 1 1.131-.024l.078.07 4.023 4.141 4.223-4.154a.89.89 0 0 1 1.128-.086l.082.066z",
    fill: "#3F3E3E",
    fillRule: "nonzero"
  })));
}

export default SvgIconChevron;